// Spinner.js
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

interface Porps {
    running: boolean
}

const Spinner = ({ running }: Porps) => {
  return (
    running ? (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    ) : null
  );
};

export default Spinner;
